export * from './dynamic-component.directive';
export * from './module';
export * from './options';



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/~/ng-dynamic/src/dynamic-component/index.js
// module id = ../../../../ng-dynamic/src/dynamic-component/index.js
// module chunks = 3